// duplicated from the owning domain package (contracts stay domain-free);
// practice/application/src/enum-sync.ts asserts they stay in lockstep
export const PRACTICE_ACCESS_SOURCES = [
    'CLINICIAN',
    'SUBSCRIPTION_CANCEL',
    'ADMIN',
    'USER',
    'OWNER',
    'EHR_BASE',
    'EHR_ACTIVE',
    'NOTES_BASE',
    'NOTES_ACTIVE',
] as const;

export type PracticeAccessSource = (typeof PRACTICE_ACCESS_SOURCES)[number];

// duplicated in subscription-contracts (contracts may not cross-import); practice/application/src/enum-sync.ts
// asserts they stay in lockstep
export const PRACTICE_PRODUCTS = ['EHR', 'NOTES'] as const;

export type PracticeProduct = (typeof PRACTICE_PRODUCTS)[number];
